import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { BankService } from 'src/app/services/bank.service';
import { CommonService } from 'src/app/services/common.service';
import { CountryService } from 'src/app/services/country.service';
import { RequestMoneyService } from '../request-money.service';

@Component({
  selector: 'app-add-request-method',
  templateUrl: './add-request-method.component.html',
  styleUrls: ['./add-request-method.component.scss']
})
export class AddRequestMethodComponent implements OnInit {
  countries=[]
  banks =[]
  bank_name
  ac_holder_name
  @ViewChild("toggleAccordian") toggleButton:ElementRef
  @Output("onMethodAdded") onMethodAdded=new EventEmitter()
  constructor(
    public requestMoneyService:RequestMoneyService,
    public common:CommonService,
    public countryService:CountryService,
    public bankService:BankService,
    public auth:AuthService
    ) { }

  ngOnInit(): void {
    this.ac_holder_name=this.auth.user.name
    this.countryService.getCountryList().subscribe((res:any)=>{
      //console.log(res)
      this.countries=res.country_list
    },err=>{
      this.requestMoneyService.messageService.add({severity:'error', summary:'Error', detail:"Cannot Fetch Country List"});
    })
  }

  saveDetails(formData:NgForm){
    //console.log(formData)
    if(formData.value.request_country!=101){
      formData.value.bank_name=this.banks.find((element)=>{
        return formData.value.bank_name_id == element.code
      }).name
    }
    this.common.showLoader()
    let data=formData.value

    this.requestMoneyService.addRequestMethod(data).subscribe(res=>{
      this.onMethodAdded.emit(true)
      formData.reset({request_country:"",request_name:this.auth.user.name,request_email:this.auth.user.email})
      this.toggle()
      this.requestMoneyService.messageService.add({severity:'success', summary:'Successful', detail:"Successfully Added Method"});
      this.common.stopLoader()
    },err=>{
      this.common.stopLoader()
      let errorKeys = Object.keys(err.error.errors);
      errorKeys.forEach(key => {
        //console.log(key)
        let value = err.error.errors[key][0];
        this.requestMoneyService.messageService.add({severity:'error', summary:'Error', detail:value});
        //console.log(value);
    });
    })
  }

/*   addRequestMethod(requestMethodForm:NgForm){
    //console.log(requestMethodForm.value)
  } */

  onCountryChange(countryId){
    if(countryId==161){
      this.ac_holder_name=null;
    }else{
      this.ac_holder_name=this.auth.user.name;
    }
    this.bank_name=null
    //console.log(countryId)
    this.setBanks(countryId)
  }

  setBanks(countryId){
    this.common.showLoader()
    this.bankService.getBankList(countryId).subscribe((res:any)=>{
        this.banks=res.bank_list
        //console.log(res)
        this.common.stopLoader()
    },err=>{
      this.common.stopLoader()
    })
  }

  getBankName(ifscCode){
    this.common.showLoader()
    this.bankService.getBankName(ifscCode).subscribe((res:any)=>{
      //console.log(res)
      if(res.status == 'success'){
        this.bank_name = res.response.BANK
      }else{
        this.requestMoneyService.messageService.add({severity:'error', summary:'Error', detail:"Cannot Find Bank"});
      }
      this.common.stopLoader()
    })
  }



  getBankNameNig(requestMethodForm){
    this.common.showLoader()
/*     if(this.auth.user.country_id==39){
      bankcode = this.banks.find(element=>{
        return element.id == bankcode
      }).code
    } */
    this.bankService.getName(requestMethodForm.value.bank_name_id,requestMethodForm.value.request_account_number).subscribe((res:any)=>{
      //console.log(res)
     if(res.result){
        this.ac_holder_name=res.name
     }
     else{
      this.requestMoneyService.messageService.add({severity:'error', summary:'Error', detail:res.message});
     }
      this.common.stopLoader()
    },err=>{
      this.bank_name=""
      this.common.stopLoader()
    })
  }
  toggle(){
    this.toggleButton.nativeElement.click()
  }


}
